class Cache {

  constructor () {
    this._mem = {};
  }

  get(key) {
    // return in-memory if we’ve seen it already
    if (key in this._mem) return this._mem[key];

    // otherwise pull from localStorage, parse once, stash in memory
    const raw = localStorage.getItem(`cache.${key}`);
    const parsed = raw ? JSON.parse(raw) : null;
    this._mem[key] = parsed;
    return parsed;
  }

  /**
   *
   * @param key
   * @param value
   */
  save(key, value) {

    const cacheItem = {
      timestamp: Date.now(),
      value,
    };

    this._mem[key] = value;
    localStorage.setItem(`cache.${key}`, JSON.stringify(cacheItem));

  }

  remove(key) {
    delete this._mem[key];
    localStorage.removeItem(`cache.${key}`);
  }

}

const CacheInstance = new Cache();

export default CacheInstance;
